import React from "react";
import { motion } from "framer-motion";

// Masked line-by-line reveal — split text into lines by \n
export function MaskedLines({ lines, delay = 0, className = "", stagger = 0.09, testId }) {
  return (
    <div className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <div key={i} className="mask-clip block overflow-hidden w-full">
          <motion.div
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              ease: [0.2, 0.7, 0.2, 1],
              delay: delay + i * stagger,
            }}
            style={{ display: "block", willChange: "transform" }}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </div>
      ))}
    </div>
  );
}

// Word-by-word masked reveal
export function MaskedWords({ text, delay = 0, className = "", stagger = 0.05 }) {
  const words = text.split(" ");
  return (
    <div className={`inline ${className}`}>
      {words.map((w, i) => (
        <span key={i} className="mask-clip mr-[0.25em]">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: [0.2, 0.7, 0.2, 1],
              delay: delay + i * stagger,
            }}
            style={{ display: "inline-block", willChange: "transform" }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

// Scroll-triggered reveal wrapper
export function Reveal({ children, delay = 0, y = 40, className = "", once = true, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1], delay }}
      className={className}
      data-testid={testId}
    >
      {children}
    </motion.div>
  );
}
